__turbopack_context__.v({
  "content": "t6Wphq_content",
  "desktopVer": "t6Wphq_desktopVer",
  "desktopVergray": "t6Wphq_desktopVergray",
  "footer": "t6Wphq_footer",
  "footerBottom___9Pav": "t6Wphq_footerBottom___9Pav",
  "footerBottom__h0Voo": "t6Wphq_footerBottom__h0Voo",
  "footerBottom__yNlit": "t6Wphq_footerBottom__yNlit",
  "footerTop___3Rx77": "t6Wphq_footerTop___3Rx77",
  "footerTop__lxFnc": "t6Wphq_footerTop__lxFnc",
  "footerTop__v1Owx": "t6Wphq_footerTop__v1Owx",
  "footergray": "t6Wphq_footergray",
  "mobileVer": "t6Wphq_mobileVer",
  "mobileVergray": "t6Wphq_mobileVergray",
  "tabletVer": "t6Wphq_tabletVer",
  "tabletVergray": "t6Wphq_tabletVergray",
});
